/**
 * 美团App目前用URL参数来定位 , lat , lng
 * */
var latReg = new RegExp("lat=([^$&]+)");
var lngReg = new RegExp("lng=([^$&]+)");

var isInMeituan = function() {
  //美团的ua不统一
  return /meituan/i.test(navigator.userAgent);
};

module.exports = function(suc, fail, next) {
  if (!isInMeituan()) {
    next();
  } else {
    var query = location.search;
    var latMatch = query.match(latReg);
    var lngMatch = query.match(lngReg);

    if (latMatch && lngMatch && !isNaN(latMatch[1]) && !isNaN(lngMatch[1])) {
      suc({
        lat: latMatch[1],
        lng: lngMatch[1]
      });
    } else {
      require.ensure([], function(require) {
        var knb = require("@dp/knb/bundle");
        knb.ready(function() {
          knb.getLocation({
            success: function(e) {
              suc({
                lat: e.lat,
                lng: e.lng
              });
            },
            fail: fail
          });
        });
      });
    }
  }
};

module.exports.type = "meituan";



// WEBPACK FOOTER //
// ./~/@dp/whereami/lib/geos/meituanapp.js